/* eslint-disable */
import React, { useState, useContext, useEffect, useCallback } from "react";
// Examples of imports of components and styles you already have in the project

import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer";
import CardContent from "@material-ui/core/CardContent";
import GridItem from "components/Grid/GridItem";
import KpiRotatingCard from "./AuxComponents/KPIRotatingV2.js";
import CardHeader from "../../../components/Card/CardHeader.js";
import Card from "../../../components/Card/Card.js";
import Button from "components/CustomButtons/Button";
import CustomTabsV2 from "components/CustomTabs/CustomTabsV2.js";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Tooltip from "@material-ui/core/Tooltip";
import EditSectionModal from "../../../components/EditSectionModal/EditSectionModal.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ViewQuilt from "@material-ui/icons/ViewQuilt";
import {
  faCalendarPlus,
  faCalendarMinus,
  faTable,
  faChartLine,
  faChartSimple,
  faExclamationTriangle,
  faFilter,
} from "@fortawesome/free-solid-svg-icons";
import CardBody from "components/Card/CardBody.js";
import dayjs from "dayjs";
import InitiativeResultsPage from "views/InitiativesProgram/initiativesResults.js";

import {
  Announcement,
  DoubleArrow,
  Visibility,
  Edit,
  AttachMoney,
  Info,
  Assessment,
  Close,
} from "@material-ui/icons";
import CardIcon from "components/Card/CardIcon.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import AuthContext from "contexts/AuthProvider.js";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
import { grayColor } from "assets/jss/material-dashboard-pro-react.js";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { useTranslation } from "react-i18next";
import { formatThresholds } from "utils/thresholdUtils"; // important function to create dynamic texts to explain each KPIs threshold for colors

import {
  Checkbox,
  FormControlLabel,
  Dialog,
  IconButton,
  AppBar,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { CheckCircle, RadioButtonUnchecked } from "@material-ui/icons";
import { client } from "../../../services/axiosClient.js";
import { ThreeDots } from "react-loader-spinner";
import OverviewTableV2 from "./AuxComponents/OverviewTableV2.js";
import { Chip, Drawer } from "@material-ui/core";
import MultiSeriesLineChartvBAR from "./AuxComponents/MultiSeriesLineChartvBAR.js";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import OnePage from "views/InitiativesProgram/OnePage_v2.js";
import { Section } from "components/Section/Section";
import ReactSelect from "react-select";
import TextField from "@material-ui/core/TextField";
import initiativeManagementStyle from "assets/jss/material-dashboard-pro-react/views/initiativesManagementStyle.js";
import InitiativeDetails from "views/InitiativesProgram/initiativeDetails.js";
import AIAssistant from "./AuxComponents/AIAssistant.js";
import InitiativeDetailsDialog from "./AuxComponents/InitiativeDetailsDialog.js";

// If you want to use the loading spinner:

const INITIATIVES_MOCK = [
  {
    id: "101",
    branch: "Branch A",
    workfront: "Workfront X",
    initiative: "Iniciativa XPTO",
    approvalGates: [
      { gateName: "Gate 1", approved: true, approvers: ["Alice"] },
      { gateName: "Gate 2", approved: false, approvers: ["Bob", "Carol"] },
    ],
    lastOnePageUpdate: "2 days ago",
    lastImplementationPlanUpdate: "2 weeks ago",
    lastPlannedResultsUpdate: "1 month ago",
  },
  {
    id: "102",
    branch: "Branch B",
    workfront: "Workfront Y",
    initiative: "Iniciativa ABC",
    approvalGates: [
      { gateName: "Gate 1", approved: true, approvers: ["Dan", "Erin"] },
      { gateName: "Gate 2", approved: true, approvers: ["Frank"] },
    ],
    lastOnePageUpdate: "3 days ago",
    lastImplementationPlanUpdate: "4 days ago",
    lastPlannedResultsUpdate: "2 days ago",
  },
];

// Function to render priority chip

function getPriorityChip(priority) {
  switch (priority) {
    case "High":
      return (
        <Chip
          label="HIGH"
          style={{
            backgroundColor: "#f44336", // Red
            color: "#fff",
            fontWeight: "bold",
          }}
          size="small"
        />
      );
    case "Medium":
      return (
        <Chip
          label="MEDIUM"
          style={{
            backgroundColor: "#ffeb3b", // Yellow
            color: "#333",
            fontWeight: "bold",
          }}
          size="small"
        />
      );
    case "Low":
      return (
        <Chip
          label="LOW"
          style={{
            backgroundColor: "#4caf50", // Green
            color: "#fff",
            fontWeight: "bold",
          }}
          size="small"
        />
      );
    default:
      return (
        <Chip
          label="UNDEFINED"
          style={{
            backgroundColor: "#9e9e9e",
            color: "#fff",
          }}
          size="small"
        />
      );
  }
}

// ----Main component -----------------------------------------
export default function WhatsHappening() {
  const { userDetails } = useContext(AuthContext);
  const clientColor = userDetails?.implementation_color;
  const defaultKpiId = userDetails?.status_kpi_id || 1;
  // console.log(userDetails);

  // ----STATE MANAGEMENT ----
  const [sections, setSections] = useState([]);
  const [selectedSectionId, setSelectedSectionId] = useState(null); // Default
  const [decisions, setDecisions] = useState([]);
  const [initiatives, setInitiatives] = useState([]);

  const [kpis, setKpis] = useState({});

  // States for the chart/timeAgg
  const [timeAggCaptura, setTimeAggCaptura] = useState("monthly");
  const [viewModeCaptura, setViewModeCaptura] = useState("chart");

  // Additional states
  const [isLoadingKpis, setIsLoadingKpis] = useState(true);
  const [isLoadingSections, setIsLoadingSections] = useState(true);
  const [viewModeOverview, setViewModeOverview] = useState("stages");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rotatingKpis, setRotatingKpis] = useState([]);
  const [isLoadingRotatingKpis, setIsLoadingRotatingKpis] = useState(true);

  const [selectedInitiative, setSelectedInitiative] = useState(null);
  const [isInitiativeDrawerOpen, setIsInitiativeDrawerOpen] = useState(false);
  const [isLoadingInitiativeDetail, setIsLoadingInitiativeDetail] =
    useState(false);
  const [selectedTab, setSelectedTab] = useState("details");

  // Hook for styles + i18n
  const useStylesCustom = makeStyles((theme) =>
    WhatsHappeningStyles(theme, clientColor)
  );

  const classes = useStylesCustom();
  const { t } = useTranslation();
  /* ——— React‑Select skin (mesmo CSS usado na tela de iniciativas) ——— */
  const customStyles = {
    control: (prov, state) => ({
      ...prov,
      minHeight: "80px",
      maxHeight: "80px",
      overflowY: "auto",
      borderColor: state.isFocused ? clientColor : prov.borderColor,
      backgroundColor: "white",
      "&:hover": { borderColor: clientColor },
    }),
    menu: (prov) => ({ ...prov, overflowY: "auto", backgroundColor: "white" }),
    option: (prov, state) => ({
      ...prov,
      color: state.isSelected ? "black" : state.isFocused ? "white" : "black",
      backgroundColor: state.isSelected
        ? "gray"
        : state.isFocused
          ? clientColor
          : "white",
      "&:active": {
        transform: "scale(0.95)",
        transition: "transform 0.2s ease",
        backgroundColor: clientColor,
      },
    }),
    multiValue: (prov) => ({ ...prov, backgroundColor: "#d3d3d3" }),
    multiValueLabel: (prov) => ({ ...prov, color: "black" }),
    multiValueRemove: (prov) => ({
      ...prov,
      color: "black",
      ":hover": { backgroundColor: "red", color: "white" },
    }),
  };

  /* placeholder renderers (obrigatórios pelo componente, mas não usados aqui) */
  const emptyRenderer = () => null;

  // -------------- useEffect: Buscar KPI no backend -------------

  useEffect(() => {
    async function fetchKpis() {
      if (!defaultKpiId) {
        // Do not fetch if no defaultKpiId is available
        // console.warn("Default KPI ID is not available. Skipping KPI fetch.");
        setIsLoadingKpis(false);
        return;
      }
      try {
        setIsLoadingKpis(true);
        const response = await client.post("/api/whatshappening-kpi-data/", {
          action: "list",
          // Use the defaultKpiId from userDetails
          kpi_ids: [defaultKpiId],
        });
        if (response.data.success) {
          setKpis(response.data.kpis);
        }
      } catch (err) {
        // console.error("Error fetching main KPI data:", err);
      } finally {
        setIsLoadingKpis(false);
      }
    }
    fetchKpis();
  }, [defaultKpiId]); // Adicione defaultKpiId como dependência

  // ENGLISH: Lift the 'isOpen' state for the AI Assistant to the parent component.
  const [isAssistantOpen, setIsAssistantOpen] = useState(false); // <<< NOVO ESTADO AQUI

  const handleToggleAssistant = () => {
    // console.log("[WhatsHappening] Toggling AI Assistant visibility."); // <<< LOG NO PAI
    setIsAssistantOpen((prev) => !prev);
  };

  // -------------- NOVO STATE e useEffect: Buscar Overview data do KPI -------------
  const [kpiOverviewData, setKpiOverviewData] = useState([]);
  const [isLoadingOverview, setIsLoadingOverview] = useState(true);
  const [stageChoices, setStageChoices] = useState([]);

  useEffect(() => {
    async function fetchKpiOverview() {
      if (!defaultKpiId) {
        // Do not fetch if no defaultKpiId is available
        /*
        console.warn(
          "Default KPI ID is not available. Skipping KPI overview fetch."
        );
        */
        setIsLoadingOverview(false);
        return;
      }
      try {
        setIsLoadingOverview(true);
        const response = await client.post(
          "/api/whatshappening-overview-data/",
          {
            action: "list",
            // Use the defaultKpiId from userDetails
            kpi_id: defaultKpiId,
          }
        );
        if (response.data.success) {
          setKpiOverviewData(
            response.data.data.map((it) => ({
              ...it,
              status: (it.status || "gray").toLowerCase(),
            }))
          );
          setStageChoices(response.data.stage_choices);
        } else {
          /*
          console.error(
            "API Error fetching overview data:",
            response.data.error
          );
          */
        }
      } catch (err) {
        // console.error("Request failed for overview data:", err);
      } finally {
        setIsLoadingOverview(false);
      }
    }
    fetchKpiOverview();
  }, [defaultKpiId]);

  // -------------------- ADICIONE ESTE useEffect --------------------
  useEffect(() => {
    async function fetchRotatingKpis() {
      if (!defaultKpiId) {
        // Do not fetch if no defaultKpiId is available
        /*
        console.warn(
          "Default KPI ID is not available. Skipping rotating KPI fetch."
        );
        */
        setIsLoadingRotatingKpis(false);
        return;
      }
      try {
        setIsLoadingRotatingKpis(true);
        const response = await client.post(
          "/api/whatshappening-rotating-kpi/",
          {
            action: "list",
            // Use the defaultKpiId from userDetails
            kpi_id: defaultKpiId,
          }
        );
        if (response.data.success) {
          setRotatingKpis(response.data.data);
        }
      } catch (error) {
        // console.error("Error fetching rotating KPIs:", error);
      } finally {
        setIsLoadingRotatingKpis(false);
      }
    }
    fetchRotatingKpis();
  }, [defaultKpiId]);

  // -------------- Agora que não estamos mais "loading", pegamos KPI ------------
  const mainKPI = kpis[String(defaultKpiId)];
  const kpiCaptura = mainKPI;

  // -------------- Extrair o chart data e checar -------------
  const chartDataCapture = kpiCaptura?.data?.[timeAggCaptura] || null;

  // -------------- Carregar Sections + Decisions --------------

  useEffect(() => {
    async function loadInitiatives() {
      try {
        const response = await client.get("/api/decision-initiatives-list/");
        if (response.data.success) {
          setInitiatives(response.data.initiatives);
        }
      } catch (error) {
        // console.error("Error loading initiatives: ", error);
      }
    }
    loadInitiatives();
  }, []);

  useEffect(() => {
    async function loadSectionsAndDecisions() {
      try {
        setIsLoadingSections(true);
        const response = await client.post(
          "/api/control-panel-sections-decisions/",
          {
            action: "list",
          }
        );
        if (response.data.success) {
          setSections(response.data.sections || []);
          setDecisions(response.data.decisions || []);
        }
      } catch (err) {
        // console.error(err);
      } finally {
        setIsLoadingSections(false);
      }
    }
    loadSectionsAndDecisions();
  }, []);

  // “isLoading” geral só fica false quando as duas requests terminaram
  const isLoading =
    isLoadingKpis ||
    isLoadingSections ||
    isLoadingOverview ||
    isLoadingRotatingKpis;

  // -------------- Escolher a section com end_date mais próxima -------------
  useEffect(() => {
    if (sections.length > 0) {
      const closestSection = getClosestSectionToToday(sections);
      if (closestSection) {
        setSelectedSectionId(closestSection.id);
      } else {
        setSelectedSectionId(sections[0].id);
      }
    }
  }, [sections]);

  // -------------- handleDecisionToggle -------------
  const handleDecisionToggle = async (decisionId, checked) => {
    try {
      const payload = {
        action: "updateDecision",
        id: decisionId,
        done: checked,
      };
      const response = await client.post(
        "/api/control-panel-sections-decisions/",
        payload
      );
      if (response.status !== 200) {
        throw new Error("Failed to update decision");
      }
      const data = response.data;
      if (data.success) {
        setDecisions((prev) =>
          prev.map((dec) =>
            dec.id === decisionId ? { ...dec, done: checked } : dec
          )
        );
      } else {
        // console.error("API error:", data.error);
      }
    } catch (error) {
      // console.error("Error toggling decision:", error);
    }
  };

  // -------------- Carregar iniciativa  -------------

  const handleInitiativeClick = async (initiativeId) => {
    try {
      setIsLoadingInitiativeDetail(true);
      setSelectedInitiative(null); // zera antes
      // Chama a mesma API que você usa em initiativesManagement
      const response = await client.post("/api/initiative-detail/", {
        action: "detail",
        initiative_id: initiativeId,
      });
      if (response.data && response.data.success) {
        setSelectedInitiative(response.data.initiative);
        setIsInitiativeDrawerOpen(true);
      } else {
        // console.error("Erro ao buscar detail:", response.data);
      }
    } catch (error) {
      // console.error("Erro no handleInitiativeClick:", error);
    } finally {
      setIsLoadingInitiativeDetail(false);
    }
  };

  // -------------- States e Handlers para KPI da Iniciativa  -------------

  const [initiativeKpisData, setInitiativeKpisData] = useState(null);
  const [isKpiLoading, setIsKpiLoading] = useState(false);
  const [kpiError, setKpiError] = useState(null);

  // ONE PAGE STATES
  const [currentOnePage, setCurrentOnePage] = useState(null); // <<< MUDANÇA: Armazena o objeto, não a lista
  const [isLoadingOnePage, setIsLoadingOnePage] = useState(false);
  const [onePageError, setOnePageError] = useState(null);

  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);
  // >>> useEffect para buscar dados de KPIs quando a iniciativa é selecionada:
  useEffect(() => {
    async function fetchKpiData() {
      try {
        if (!selectedInitiative?.id) {
          setInitiativeKpisData(null);
          return;
        }
        setIsKpiLoading(true);
        setKpiError(null);

        const response = await client.post("/api/initiative-results-data/", {
          action: "list",
          initiative_id: selectedInitiative.id,
        });

        if (response.data.success) {
          setInitiativeKpisData(response.data.data);
        } else {
          // console.error("Error fetching KPI data:", err);
          setKpiError(response.data.error || "Failed to fetch KPI data");
        }
      } catch (err) {
        // console.error("Error fetching KPI data:", err);
        setKpiError("Could not contact the server");
      } finally {
        setIsKpiLoading(false);
      }
    }

    fetchKpiData();
  }, [selectedInitiative]);

  // >>> Refactored function to fetch OnePage data
  const fetchOnePageData = useCallback(async (initiativeId) => {
    if (!initiativeId) {
      setCurrentOnePage(null);
      return;
    }
    try {
      setIsLoadingOnePage(true);
      setOnePageError(null);

      /*
      console.log(
        `[DEBUG] WhatsHappening: Fetching OnePage for initiative ID: ${initiativeId}`
      );
      */

      const response = await client.post("/api/whatshappening-onepage/", {
        initiative_id: initiativeId,
      });

      /*
      console.log(
        "[DEBUG] WhatsHappening: API Response Received:",
        response.data
      );
      */

      if (response.data.success) {
        // Log do que está sendo setado no estado
        /*
        console.log(
          "[DEBUG] WhatsHappening: Setting currentOnePage to:",
          response.data.onepage_data
        );
        */
        setCurrentOnePage(response.data.onepage_data);
      } else {
        /*
        console.error(
          "[DEBUG] WhatsHappening: API returned an error:",
          response.data.error
        );
        */
        setOnePageError(response.data.error || "Failed to fetch OnePage data");
        setCurrentOnePage(null);
      }
    } catch (err) {
      // console.error("[DEBUG] WhatsHappening: Network/Request Error:", err);
      setOnePageError("Could not contact the server");
      setCurrentOnePage(null);
    } finally {
      setIsLoadingOnePage(false);
    }
  }, []);

  useEffect(() => {
    if (selectedInitiative?.id) {
      fetchOnePageData(selectedInitiative.id);
    } else {
      setCurrentOnePage(null);
    }
  }, [selectedInitiative, fetchOnePageData]);
  // COMPONENTE: Conteúdo da aba Results

  // -------------- Aux function to find closest section -------------
  function getClosestSectionToToday(sectionsArray) {
    const today = dayjs();
    let closestSection = null;
    let minDiff = Infinity;
    for (const section of sectionsArray) {
      if (!section.end_date) continue;
      const diffAbs = Math.abs(dayjs(section.end_date).diff(today, "days"));
      if (diffAbs < minDiff) {
        minDiff = diffAbs;
        closestSection = section;
      }
    }
    return closestSection;
  }

  // -------------- Toggling "Monthly"/"Yearly" + "chart"/"table" -------------
  const toggleTimeAggCaptura = () => {
    setTimeAggCaptura((prev) => (prev === "monthly" ? "yearly" : "monthly"));
  };
  const toggleViewModeCaptura = () => {
    setViewModeCaptura((prev) => (prev === "chart" ? "table" : "chart"));
  };
  const toggleViewModeOverview = () => {
    if (viewModeOverview === "table") {
      setViewModeOverview("stages");
    } else if (viewModeOverview === "stages") {
      setViewModeOverview("drilldown");
    } else {
      setViewModeOverview("table");
    }
  };

  // -------------- Modal -------------
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleClose = () => {
    setIsInitiativeDrawerOpen(false);
  };

  // -------------- Some style definitions -------------
  const selectedSection = sections.find((s) => s.id === selectedSectionId);

  // -------------- Floating Card -------------
  const renderFloatingCard = () => {
    const selectedSec = sections.find((s) => s.id === selectedSectionId);
    if (!selectedSec) return null; // If you don't find it, you return null

    return (
      <div className={classes.floatingCard}>
        <div className={classes.floatingCardTitle}>
          {selectedSec.section_name}
          <span style={{ marginLeft: 2, fontSize: "12px", color: "#666" }}>
            | {t("whatshappening.card_footer.period")}{" "}
            {selectedSec.start_date || "?"} -&gt; {selectedSec.end_date || "?"}
          </span>
        </div>
        {/* Edit button */}
        <Tooltip title={t("program_meeting.actions.edit_section")}>
          <Edit
            className={classes.iconButtonCustom}
            onClick={handleOpenModal}
            style={{
              cursor: "pointer",
              fontSize: "20px",
            }}
          />
        </Tooltip>
        {/* Modal to select new section */}
        <EditSectionModal
          open={isModalOpen}
          handleClose={handleCloseModal}
          sections={sections}
          setSelectedSectionId={setSelectedSectionId}
          clientColor={clientColor} // <= Pass the color
        />
      </div>
    );
  };
  // -------------- Styles function -------------
  function WhatsHappeningStyles(theme, cColor) {
    return {
      ...initiativeManagementStyle(theme, clientColor),
      ...customSelectStyle(theme, cColor),
      ...customInputStyle(cColor),
      root: {
        padding: 0,
        margin: 0,
      },
      tabsRoot: {
        backgroundColor: grayColor[8],
      },
      tabRoot: {
        fontSize: "1rem",
        fontWeight: 400,
        color: cColor,
        textTransform: "none",
        "&:hover": {
          color: cColor,
          opacity: 1,
        },
        "&.Mui-selected": {
          color: "black",
          fontWeight: 500,
          borderBottom: `2px solid ${cColor}`,
        },
        "&:focus": {
          color: cColor,
        },
      },
      indicator: {
        backgroundColor: cColor,
        height: "1.5px",
      },
      cardIconTitle: {
        ...cardTitle,
        marginTop: "0px",
        marginBottom: "0px",
        padding: "10px",
        fontSize: "15px",
      },
      addButton: {
        marginBottom: theme.spacing(2),
        height: "22px !important",
        width: "30px !important",
        minWidth: "0 !important",
        position: "relative",
        transition: "all 0.2s",
        margin: "10px 0 0 10px !important",
        padding: "0 !important",
      },
      cardButton: {
        padding: "0 !important",
        margin: "0 !important",
        height: "30px !important",
        width: "30px !important",
        minWidth: "0 !important",
        position: "relative",
        transition: "all 0.2s",
      },
      cardButtonIcon: {
        margin: "0 !important",
        position: "absolute !important",
        top: "50% !important",
        left: "50% !important",
        transform: "translate(-50%, -50%)",
        width: "18px !important",
        height: "18px !important",
        color: "#FFFFFF",
      },
      iconButtonCustom: {
        cursor: "pointer",
        "&:hover": {
          color: cColor,
        },
      },
      actionIconsCustom: {
        display: "flex",
        gap: theme.spacing(1),
        justifyContent: "center",
        alignItems: "center",
      },
      center: {
        textAlign: "center",
      },
      tableHeadCell: {
        fontWeight: "bold",
        backgroundColor: "white",
        cursor: "pointer",
      },
      floatingCard: {
        position: "fixed",
        top: 0,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1200,
        backgroundColor: "#fff",
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
        borderRadius: "0 0 8px 8px",
        padding: "6px 4px 4px 10px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        maxWidth: "90%",
        [theme.breakpoints.down("sm")]: {
          position: "static",
          alignItems: "center",
          maxWidth: "100%",
          transform: "none",
          zIndex: 1200,
          borderRadius: 0,
          margin: "-40px 15px 37px 0",
          backgroundColor: "#EEEE",
          borderBottom: "1px solid " + grayColor[4],
          boxShadow: "none",
        },
      },
      floatingCardTitle: {
        fontSize: "14px",
        color: "#333",
        marginRight: "10px",
        [theme.breakpoints.down("sm")]: {
          fontSize: "12px",
        },
      },
      sortIndicator: {
        marginLeft: theme.spacing(1),
        fontSize: "0.8rem",
      },
      filterContainer: {
        marginBottom: theme.spacing(2),
        display: "flex",
        alignItems: "center",
      },
      filterItem: {
        marginRight: theme.spacing(2),
        minWidth: 200,
      },
      accordionRootCustom: {
        marginBottom: theme.spacing(0.2),
        overflow: "hidden",
        boxShadow: "none",
        "&:before": {
          display: "none",
        },
        "&:first-of-type": {
          borderRadius: "10px 10px 10px 10px",
        },
        "&:nth-of-type(2)": {
          borderRadius: "10px 10px 10px 10px",
        },
        "&:last-of-type": {
          borderRadius: "10px 10px 10px 10px",
        },
      },
      textFieldRoot: {
        "& .MuiInput-underline:before": {
          borderBottom: "1px solid #ccc",
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
          borderBottom: `2px solid ${cColor}`,
        },
        "& .MuiInput-underline:after": {
          borderBottom: `2px solid ${cColor}`,
        },
      },
      inputText: {
        color: "#666",
        "&:focus": {
          color: "#666",
        },
      },
      labelText: {
        color: "#666",
        "&.Mui-focused": {
          color: "#666",
        },
      },
      sortIcon: {
        fontSize: "14px",
        marginLeft: "6px",
        color: "#ccc",
      },
      activeSortIcon: {
        color: "#aaa",
      },
      stats: {
        color: grayColor[0],
        fontSize: "10px",
        lineHeight: "22px",
        display: "inline-flex",
        "& svg": {
          position: "relative",
          top: "3px",
          width: "16px",
          height: "16px",
          marginRight: "5px",
        },
        "& .fab,& .fas,& .far,& .fal,& .material-icons": {
          position: "relative",
          top: "3px",
          fontSize: "16px",
          marginRight: "3px",
        },
      },
      statusCircle: {
        position: "absolute",
        top: "8px",
        right: "-8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "30px",
        height: "30px",
        borderRadius: "50%",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        cursor: "pointer",
      },
      modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      sectionList: {
        listStyle: "none",
        padding: 0,
        margin: 0,
      },
      paper: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2, 4, 3),
        maxHeight: "80vh",
        overflowY: "auto",
        borderRadius: "10px",
      },
      sectionListItem: {
        padding: theme.spacing(1),
        borderBottom: `1px solid ${cColor}`,
        cursor: "pointer",
        "&:hover": {
          backgroundColor: `${cColor}2A`,
        },
      },
      funnelBar: {
        background: `linear-gradient(135deg, ${cColor}33 0%, ${cColor} 100%)`,
        color: "#fff",
        margin: "0 auto",
        padding: "14px 0",
        borderRadius: "6px",
        transition: "width 0.3s ease-in-out",
        boxShadow: "0 0 6px rgba(0,0,0,0.2)",
        fontWeight: "bold",
      },
      cardBody: {
        flex: 1,
        overflow: "auto",
        maxHeight: "calc(45vh - 100px)", // Default max-height for card bodies; will override in specific cases
        padding: "0.9375rem 20px", // Same padding as Material-UI default cardBody for consistency
        fontSize: "0.8rem", // Uniform font size
        lineHeight: "1.5", // Uniform line spacing
        color: "#3C3C3C", // Uniform font color
      },
      textStyle: {
        fontFamily: "inherit", // Inherit the parent font or set a desired font-family (ex.: '"Roboto", sans-serif')
        fontSize: "0.8rem", // Standard font size
        lineHeight: "1.5", // Standard line height
        color: "#3C3C3C", // Standard text color
      },
    };
  }

  return (
    <div>
      {/* Render the floating card */}
      {renderFloatingCard()}
      <GridContainer
        spacing={0}
        style={{ marginTop: "-40px", overflow: "hidden" }}
      >
        {/* ========== KEY MESSAGES ========== */}
        <GridItem
          xs={12}
          sm={12}
          md={3}
          style={{ display: "flex", padding: 0, margin: 0 }}
        >
          <Card style={{ flex: 1, height: "90%" }}>
            <CardHeader
              color="client"
              icon
              style={{ position: "relative", paddingRight: "20px" }}
            >
              <CardIcon color="client">
                <Announcement />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("whatshappening.cards_title.program_key_messages")}
              </h4>
              <div
                className={classes.statusCircle}
                style={{
                  background:
                    selectedSection?.status === "Green"
                      ? "linear-gradient(135deg, #66bb6a 0%, #43a047 100%)"
                      : selectedSection?.status === "Red"
                        ? "linear-gradient(135deg, #ef5350 0%, #e53935 100%)"
                        : selectedSection?.status === "Yellow"
                          ? "linear-gradient(135deg, #ffd54f 0%, #ffc107 100%)"
                          : "linear-gradient(135deg, #bdbdbd 0%, #9e9e9e 100%)",
                  boxShadow:
                    selectedSection?.status === "Green"
                      ? "0 0 10px rgba(67,160,71,0.4)"
                      : selectedSection?.status === "Red"
                        ? "0 0 10px rgba(229,57,53,0.4)"
                        : selectedSection?.status === "Yellow"
                          ? "0 0 10px rgba(255,193,7,0.4)"
                          : "0 0 10px rgba(158,158,158,0.4)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.3)";
                  e.currentTarget.style.boxShadow =
                    selectedSection?.status === "Green"
                      ? "0 0 10px rgba(76,175,80,0.4)"
                      : selectedSection?.status === "Red"
                        ? "0 0 10px rgba(244,67,54,0.4)"
                        : selectedSection?.status === "Yellow"
                          ? "0 0 10px rgba(255,235,59,0.4)"
                          : "0 0 10px rgba(189,189,189,0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
            </CardHeader>
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <ThreeDots
                  color={userDetails.implementation_color}
                  height={80}
                  width={80}
                  ariaLabel="loading"
                />
              </div>
            ) : (
              <>
                <CardBody
                  className={classes.cardBody}
                  style={{
                    flex: 1,
                    overflow: "auto",
                    maxHeight: "calc(45vh - 100px)",
                  }}
                >
                  <PerfectScrollbar>
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          sections.find((s) => s.id === selectedSectionId)
                            ?.keyMessage ||
                          t("whatshappening.messages.no_message_available"),
                      }}
                      className={classes.textStyle}
                    />
                  </PerfectScrollbar>
                </CardBody>
              </>
            )}
          </Card>
        </GridItem>
        {/* ========== NEXT STEPS ========== */}
        <GridItem
          xs={12}
          sm={12}
          md={3}
          style={{ display: "flex", padding: 0, margin: 0 }}
        >
          <Card style={{ flex: 1, height: "90%" }}>
            <CardHeader
              color="client"
              icon
              style={{ position: "relative", paddingRight: "20px" }}
            >
              <CardIcon color="client">
                <DoubleArrow />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("whatshappening.cards_title.program_next_steps")}
              </h4>
            </CardHeader>
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <ThreeDots
                  color={userDetails.implementation_color}
                  height={80}
                  width={80}
                  ariaLabel="loading"
                />
              </div>
            ) : (
              <>
                <CardBody
                  className={classes.cardBody}
                  style={{
                    flex: 1,
                    overflow: "auto",
                    maxHeight: "calc(45vh - 100px)",
                  }}
                >
                  <PerfectScrollbar>
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          sections.find((s) => s.id === selectedSectionId)
                            ?.next_steps ||
                          t("whatshappening.messages.no_message_available"),
                      }}
                      className={classes.textStyle}
                    />
                  </PerfectScrollbar>
                </CardBody>
              </>
            )}
          </Card>
        </GridItem>

        {/* ========== Decisions Needed =========== */}
        <GridItem
          xs={12}
          sm={12}
          md={3}
          style={{ display: "flex", padding: 0, margin: 0 }}
        >
          <Card style={{ flex: 1, height: "90%" }}>
            <CardHeader color="client" icon>
              <CardIcon color="client">
                <FontAwesomeIcon icon={faExclamationTriangle} />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("whatshappening.cards_title.decisions_needed")}
              </h4>
            </CardHeader>
            <CardBody
              className={classes.cardBody}
              style={{
                flex: 1,
                overflow: "auto",
                maxHeight: "calc(45vh - 100px)",
              }}
            >
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <ThreeDots
                    color={userDetails.implementation_color}
                    height={100}
                    width={80}
                    ariaLabel="loading"
                  />
                </div>
              ) : (
                <PerfectScrollbar>
                  {decisions
                    .filter((dec) => dec.section_id === selectedSectionId)
                    .sort((a, b) => {
                      const priorityOrder = { High: 1, Medium: 2, Low: 3 };
                      return (
                        priorityOrder[a.priority] - priorityOrder[b.priority]
                      );
                    })
                    .map((d) => {
                      const initiative = initiatives.find(
                        (i) => String(i.id) === String(d.initiative_id)
                      );
                      return (
                        <div
                          key={d.id}
                          style={{
                            marginBottom: "0px",
                            borderBottom: "1px solid #ccc",
                            paddingBottom: "0px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {getPriorityChip(d.priority)}
                            <strong
                              className={classes.textStyle}
                              style={{
                                color: clientColor,
                              }}
                            >
                              {initiative
                                ? initiative.name
                                : t("whatshappening.labels.program_related")}
                            </strong>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={d.done}
                                  onChange={(e) =>
                                    handleDecisionToggle(d.id, e.target.checked)
                                  }
                                  icon={
                                    <RadioButtonUnchecked
                                      style={{ color: "#aaa" }}
                                    />
                                  }
                                  checkedIcon={
                                    <CheckCircle
                                      style={{ color: clientColor }}
                                    />
                                  }
                                />
                              }
                              style={{ marginTop: "0px" }}
                            />
                          </div>
                          <div
                            className={classes.textStyle}
                            style={{
                              fontWeight: "bold",
                              margin: "4px 0",
                            }}
                          >
                            {d.decisionTitle}
                          </div>
                          <div
                            className={classes.textStyle}
                            style={{
                              color: "#3C3C3C",
                            }}
                          >
                            {d.decisionDescription}
                          </div>
                        </div>
                      );
                    })}
                  {decisions.filter(
                    (dec) => dec.section_id === selectedSectionId
                  ).length === 0 && (
                    <p style={{ color: "#999", fontSize: "0.9rem" }}>
                      {t("whatshappening.messages.no_decisions")}
                    </p>
                  )}
                </PerfectScrollbar>
              )}
            </CardBody>
          </Card>
        </GridItem>

        {/* ========== KPI ROTATING CARD ========== */}
        <GridItem xs={12} sm={12} md={3}>
          <Card style={{ flex: 1, height: "90%" }}>
            <CardHeader color="client" icon>
              <CardIcon color="client">
                <Assessment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("whatshappening.cards_title.key_metrics")}
              </h4>
            </CardHeader>

            {/* Se estiver carregando, exibe o spinner no lugar do conteúdo */}
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <ThreeDots
                  color={userDetails.implementation_color}
                  height={80}
                  width={80}
                  ariaLabel="loading"
                />
              </div>
            ) : (
              <CardContent
                style={{
                  flex: 1,
                  overflow: "hidden",
                  position: "relative",
                  padding: "0px 0px 30px 0px",
                }}
              >
                {/* Seu componente de conteúdo, sem Card interno */}
                <KpiRotatingCard kpisData={rotatingKpis} />
              </CardContent>
            )}
          </Card>
        </GridItem>

        {/* ========== status table ========== */}
        <GridItem xs={12} sm={12} md={7} style={{ marginTop: "-5px" }}>
          <Card style={{ height: "47vh" }}>
            <CardHeader color="client" icon>
              <CardIcon color="client">
                <Visibility />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("whatshappening.cards_title.overview")}
                {viewModeOverview === "table" && (
                  <>
                    {" "}
                    - <b>{t("whatshappening.cards_title.table")}</b>
                  </>
                )}
                {viewModeOverview === "stages" && (
                  <>
                    {" "}
                    - <b>{t("whatshappening.cards_title.stages")}</b>
                  </>
                )}
                {viewModeOverview === "drilldown" && (
                  <>
                    {" "}
                    - <b>{t("whatshappening.cards_title.drilldown")}</b>
                  </>
                )}
              </h4>
              <div
                style={{
                  position: "absolute",
                  right: "0px",
                  top: "10px",
                  zIndex: 1000,
                }}
              >
                <Tippy
                  content={
                    viewModeOverview === "table"
                      ? t("whatshappening.buttons.see_stages")
                      : viewModeOverview === "stages"
                        ? t("whatshappening.buttons.view_drilldown")
                        : t("whatshappening.buttons.view_table")
                  }
                  arrow={true}
                  theme="light"
                >
                  <Button
                    color="client"
                    size="sm"
                    variant="outlined"
                    onClick={toggleViewModeOverview}
                    className={classes.cardButton}
                  >
                    <FontAwesomeIcon
                      icon={
                        viewModeOverview === "table"
                          ? faFilter // se estou em table, ao clicar vou para stages
                          : viewModeOverview === "stages"
                            ? faChartSimple // se estou em stages, ao clicar vou para drilldown
                            : faTable // se estou em drilldown, ao clicar vou para table
                      }
                      className={classes.cardButtonIcon}
                    />
                  </Button>
                </Tippy>
              </div>
            </CardHeader>
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <ThreeDots
                  color={userDetails.implementation_color}
                  height={80}
                  width={80}
                  ariaLabel="loading"
                />
              </div>
            ) : (
              <CardContent
                style={{
                  flex: 1,
                  padding: 0,
                  overflow: "hidden",
                  height: "calc(30vh - 60px)",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center", // Centraliza verticalmente
                  alignItems: "center", // Opcional: centraliza horizontalmente se necessário
                }}
              >
                <PerfectScrollbar
                  style={{ width: "100%", height: "100%" }}
                  options={{ suppressScrollX: false }}
                >
                  <OverviewTableV2
                    selectedSection={selectedSection}
                    viewModeOverview={viewModeOverview}
                    kpiOverviewData={kpiOverviewData}
                    stageChoices={stageChoices} // Nova prop para ordenar os stages
                    unit={kpiOverviewData?.[0]?.kpiUnit || ""}
                    showUnitBefore={true}
                    onInitiativeClick={handleInitiativeClick}
                    initiativeDetailsOpen={isInitiativeDrawerOpen}
                  />
                </PerfectScrollbar>
              </CardContent>
            )}
          </Card>
        </GridItem>

        {/* ========== Graphs ========== */}
        <GridItem xs={12} sm={12} md={5}>
          <GridContainer direction="column">
            <GridItem
              xs={12}
              sm={12}
              md={12}
              style={{ display: "flex", marginTop: "-5px" }}
            >
              <Card
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  height: "47vh",
                }}
              >
                <GridItem>
                  <CardHeader
                    color="client"
                    icon
                    className={classes.cardHeader}
                  >
                    <CardIcon color="client">
                      <AttachMoney />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>
                      {t("whatshappening.cards_title.graphcapture_v3")}
                    </h4>
                    <div
                      style={{
                        position: "absolute",
                        right: "40px",
                        top: "10px",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Tippy
                        content={
                          <span
                            dangerouslySetInnerHTML={{
                              __html: formatThresholds(kpiCaptura),
                            }}
                          />
                        }
                        theme="light"
                      >
                        <Info
                          style={{
                            fontSize: "18px",
                            color: "#666",
                            cursor: "pointer",
                          }}
                        />
                      </Tippy>
                      <Tippy
                        content={
                          timeAggCaptura === "monthly"
                            ? t("whatshappening.buttons.view_yearly")
                            : t("whatshappening.buttons.view_monthly")
                        }
                        arrow={true}
                        theme="light"
                      >
                        <Button
                          color="client"
                          size="small"
                          variant="outlined"
                          onClick={toggleTimeAggCaptura}
                          className={classes.cardButton}
                        >
                          <FontAwesomeIcon
                            icon={
                              timeAggCaptura === "monthly"
                                ? faCalendarPlus
                                : faCalendarMinus
                            }
                            className={classes.cardButtonIcon}
                          />
                        </Button>
                      </Tippy>
                    </div>

                    <div
                      style={{
                        position: "absolute",
                        right: "0px",
                        top: "10px",
                        zIndex: 1000,
                      }}
                    >
                      <Tippy
                        content={
                          viewModeCaptura === "chart"
                            ? t("whatshappening.buttons.view_table")
                            : t("whatshappening.buttons.view_chart")
                        }
                        arrow={true}
                        theme="light"
                      >
                        <Button
                          color="client"
                          size="small"
                          variant="outlined"
                          onClick={toggleViewModeCaptura}
                          className={classes.cardButton}
                        >
                          <FontAwesomeIcon
                            icon={
                              viewModeCaptura === "chart"
                                ? faTable
                                : faChartLine
                            }
                            className={classes.cardButtonIcon}
                          />
                        </Button>
                      </Tippy>
                    </div>
                  </CardHeader>
                </GridItem>
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <ThreeDots
                      color={userDetails.implementation_color}
                      height={80}
                      width={80}
                      ariaLabel="loading"
                    />
                  </div>
                ) : (
                  <CardBody
                    style={{
                      flex: 1,
                      overflow: "hidden",
                      marginTop: "-20px",
                      marginBottom: "-10px",
                    }}
                  >
                    {chartDataCapture ? (
                      <MultiSeriesLineChartvBAR
                        timeAgg={timeAggCaptura}
                        viewMode={viewModeCaptura}
                        data={chartDataCapture}
                        thresholdsConfig={kpiCaptura.thresholdsConfig}
                        unit={kpiCaptura?.unit || ""}
                        showUnitBefore={true}
                      />
                    ) : (
                      <p style={{ color: "#999", fontSize: "0.9rem" }}>
                        {t("whatshappening.messages.data_unavailable")}
                      </p>
                    )}
                  </CardBody>
                )}
              </Card>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      <InitiativeDetailsDialog
        isOpen={isInitiativeDrawerOpen}
        onClose={() => setIsInitiativeDrawerOpen(false)}
        selectedInitiative={selectedInitiative}
        isLoadingInitiativeDetail={isLoadingInitiativeDetail}
        clientColor={clientColor}
        classes={classes}
        t={t}
        userDetails={userDetails}
        customStyles={customStyles}
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={setSelectedTabIndex}
        initiativeKpisData={initiativeKpisData}
        isKpiLoading={isKpiLoading}
        kpiError={kpiError}
        currentOnePage={currentOnePage}
        isLoadingOnePage={isLoadingOnePage}
        onePageError={onePageError}
      />
      <AIAssistant
        key={isAssistantOpen ? "open" : "closed"}
        classes={classes}
        t={t}
        clientColor={clientColor}
        isOpen={isAssistantOpen}
        onToggle={handleToggleAssistant}
      />
    </div>
  );
}
